"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef, useContext, useMemo, useState } from "react";
import { PortalContainerProvider } from "../../contexts/index.js";
import { cn } from "../../utils/cn.js";
import { mergeRefs } from "../../utils/mergeRefs.js";
import { drawerVariants } from "./Drawer.variants.js";
import { DrawerInsetContext } from "./DrawerPortal.js";
import { useResponsiveDrawerDirection } from "./useResponsiveDrawerDirection.js";
const DrawerPopup_DrawerPopup = /*#__PURE__*/ forwardRef(function({ className, slots, size, direction, height, children, ...props }, ref) {
    const isInsetActive = useContext(DrawerInsetContext);
    const effectiveDirection = useResponsiveDrawerDirection(direction, isInsetActive);
    const { popup } = drawerVariants({
        size,
        direction: effectiveDirection,
        inset: true === isInsetActive,
        height
    });
    const [container, setContainer] = useState(null);
    const mergedRef = useMemo(()=>mergeRefs(ref, setContainer), [
        ref
    ]);
    return /*#__PURE__*/ jsx(Drawer.Popup, {
        ref: mergedRef,
        className: cn(popup(), className, slots?.popup),
        ...props,
        children: /*#__PURE__*/ jsx(PortalContainerProvider, {
            container: container,
            children: children
        })
    });
});
export { DrawerPopup_DrawerPopup as DrawerPopup };
